import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from '../loader';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();
  count = 0;
  constructor() { }
  show() {
    this.count++;
    this.loaderSubject.next({ show: true } as LoaderState);
  }
  hide() {
    this.count--;
    if (this.count <= 0) {
      this.loaderSubject.next({ show: false } as LoaderState);
    }
  }
}
